import { useState } from "react"
import { Input } from "../../components"
import { BlackButton, ButtonIcon, Form, Label } from "../../styles"

const Information = ({ onContinue }) => {
	const [name, setName] = useState("")
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [repeatPassword, setRepeatPassword] = useState("")

	const _register = (e) => {
		if (e) {
			e.preventDefault()
		}

		onContinue({ email, password, name })
	}

	return (
		<Form style={{ alignSelf: "stretch" }} onSubmit={_register}>
			<Label>
				Name
				<Input
					placeholder="Name"
					type="text"
					value={name}
					onChange={(value) => setName(value)}
				/>
			</Label>
			<Label>
				Email
				<Input
					placeholder="Email"
					type="email"
					value={email}
					onChange={(value) => setEmail(value)}
				/>
			</Label>
			<Label>
				Password
				<Input
					placeholder="Password"
					type="password"
					value={password}
					onChange={(value) => setPassword(value)}
				/>
			</Label>
			<Label>
				Repeat password
				<Input
					placeholder="Password"
					type="password"
					value={repeatPassword}
					onChange={(value) => setRepeatPassword(value)}
				/>
			</Label>
			<BlackButton
				style={{ alignSelf: "center", marginTop: "50px" }}
				type="submit"
				disabled={
					name.length === 0 ||
					email.length === 0 ||
					password.length === 0 ||
					password !== repeatPassword
				}
			>
				<ButtonIcon
					src="/assets/images/arrowRight.svg"
					color="white"
					width="21px"
					height="14px"
				/>
			</BlackButton>
		</Form>
	)
}

export default Information
